export default "__VITE_ASSET__CWAV_XnO__"